fragment SlackChannelBasic on SlackChannel {
    display
    externalId
}
